import {
  PayoutOrderListFilter,
  PayoutOrderListFilterFormData,
} from '@/models/payout-order/payout-order-list-filter.model';

type PayoutOrderListFilterExternalIdList = Pick<PayoutOrderListFilter, 'tagIdList' | 'segmentIdList'>;

export const payoutOrderListFilterDtoToApi = (
  { tagList, segmentList, ...payoutOrderListFilterDto }: PayoutOrderListFilterFormData,
  { tagIdList, segmentIdList }: PayoutOrderListFilterExternalIdList,
): PayoutOrderListFilter => {
  return {
    ...payoutOrderListFilterDto,
    tagIdList,
    segmentIdList,
  };
};
